import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../data/site";

export const StickyCallButton = () => (
    <div data-testid="sticky-call-bar" className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-white border-t border-slate-100 p-3 shadow-[0_-4px_12px_rgb(0,0,0,0.06)]">
        <a
            href={PHONE_TEL}
            data-testid="sticky-call-now-button"
            className="flex items-center justify-center gap-2 bg-[#ea580c] active:bg-[#c2410c] text-white rounded-full px-6 py-3 font-semibold w-full shadow-lg shadow-orange-500/20"
        >
            <Phone className="w-4 h-4" />
            Call Now — {PHONE_DISPLAY}
        </a>
    </div>
);
